import React from 'react'
import TransitionLink from 'gatsby-plugin-transition-link'
import PropTypes from 'prop-types'
import { Location } from '@reach/router'

const PageLink = ({ to, className, children }) => {
  return (
    <Location>
      {({ location }) => {
        const inAdmin = location.pathname.includes('admin')
        if (inAdmin) {
          return <a className={className}>{children}</a>
        } else {
          return (
            <TransitionLink
              className={className}
              to={to}
              exit={{
                length: 0,
              }}
              entry={{
                delay: 0,
              }}
            >
              {children}
            </TransitionLink>
          )
        }
      }}
    </Location>
  )
}

PageLink.propTypes = {
  children: PropTypes.node.isRequired,
  to: PropTypes.string.isRequired,
  className: PropTypes.string,
}

export default PageLink
